import React from 'react';
import { getFile } from 'xopsUtils';
import { Modal, Button, Icon } from 'semantic-ui-react';
import { apolloClientHolder } from '@crispico/foundation-react';
import { GENERATE_PDF, GET_UNIT_TYPES_OPTIONS } from './queries';
import { ModalExt } from '@crispico/foundation-react/components/ModalExt/ModalExt';
import { SelectExt, SelectExtOption } from '@crispico/foundation-react/components/selectExt/SelectExt';

interface InvoiceGeneratePdfModalProps {
    showModal: boolean;
    entityId: number | undefined;
    onClose: () => void;
}

interface InvoiceGeneratePdfState {
    options: { value: string; label: string }[];
    selectedOptions: string[];
}

export class InvoiceGeneratePdfModal extends React.Component<InvoiceGeneratePdfModalProps, InvoiceGeneratePdfState> {
    constructor(props: InvoiceGeneratePdfModalProps) {
        super(props);
        this.state = {
            options: [],
            selectedOptions: []
        }
    }

    componentDidUpdate(prevProps: Readonly<InvoiceGeneratePdfModalProps>): void {
        if(prevProps.entityId !== this.props.entityId) {
            this.getUnitTypesOptions();
        }
    }

    protected async downloadPDF() {
        if (!this.props.entityId) {
            return;
        }
        const pdfPath: string = (await apolloClientHolder.apolloClient.query({ query: GENERATE_PDF, variables: { invoiceId: this.props.entityId, acceptedTaskTypes: this.state.selectedOptions }, context: { showSpinner: true } })).data.invoiceService_generatePDF;
        const downloadURL = getFile(pdfPath);
        window.open(downloadURL)
        this.props.onClose();
    }

    protected async getUnitTypesOptions() {
        if (!this.props.entityId) {
            return [];
        }
        const unitTypes = (await apolloClientHolder.apolloClient.query({ query: GET_UNIT_TYPES_OPTIONS, variables: { invoiceId: this.props.entityId } })).data.invoiceService_unitTypesFromInvoice;
        this.setState({ options: unitTypes.map((type: string) => ({ value: type, label: type })) });
    }

    render() {
        return <>
            <ModalExt size="tiny" open={this.props.showModal} onClose={() => this.props.onClose()} >
                <Modal.Header><Icon name="print"/>{_msg("InvoiceGeneratePdfModal.unitTypes.label")}</Modal.Header>
                <Modal.Content>
                    <SelectExt options={this.state.options} isMulti={true} 
                        placeholder={_msg("InvoiceGeneratePdfModal.unitTypes.label")} 
                        onSelectedOptionsChange={(selectedOptions: SelectExtOption[]) => this.setState({ selectedOptions: selectedOptions.map(option => option.value) })} />
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => this.downloadPDF()}>{_msg("general.ok")}</Button>
                    <Button onClick={() => this.props.onClose()}>{_msg("general.cancel")}</Button>
                </Modal.Actions>
            </ModalExt>
        </>
    }
}